import { CallDetailOverviewRow } from '@/types/call-detail-overview';

export function toUtcISOString(value: string): string {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    throw new Error(`Invalid date value: ${value}`);
  }
  return date.toISOString();
}

export function isWithinUtcInclusive(
  startTime: string,
  startUtc: string,
  endUtc: string
): boolean {
  const time = Date.parse(startTime);
  const start = Date.parse(startUtc);
  const end = Date.parse(endUtc);

  if ([time, start, end].some((v) => Number.isNaN(v))) {
    return false;
  }

  return time >= start && time <= end;
}

export function filterRowsWithValidStartTime(
  rows: CallDetailOverviewRow[]
): { validRows: CallDetailOverviewRow[]; excludedCount: number } {
  const validRows = rows.filter((row) => !Number.isNaN(Date.parse(row.startTime)));
  return {
    validRows,
    excludedCount: rows.length - validRows.length,
  };
}
